<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">
            <x-form-group label="Judul" :error="getError('title')">
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.title"
                />
            </x-form-group>

            <x-form-group
                label="Isi"
                :error="getError('content')"
                :is-required="true"
            >
                <textarea class="form-control" v-model="fields.content" />
            </x-form-group>

            <x-form-group
                label="Nomor Tujuan"
                :error="getError('destinations')"
                :is-required="true"
            >
                <x-table :headers="['', 'Jemaat', 'Nomor HP']">
                    <tr
                        v-for="(destination, index) in fields.destinations"
                        :key="index"
                    >
                        <td>
                            <x-delete-item-button
                                @click="deleteDestination(index)"
                            />
                        </td>
                        <td>
                            <x-form-group
                                :error="
                                    getError(`destinations.${index}.member_id`)
                                "
                            >
                                <x-input-member
                                    type="text"
                                    class="form-control"
                                    :value="destination.member_id"
                                    @input="
                                        (member) =>
                                            setMember(destination, member)
                                    "
                                />
                            </x-form-group>
                        </td>
                        <td>
                            <x-form-group
                                :error="getError(`destinations.${index}.phone`)"
                            >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="destination.phone"
                                />
                            </x-form-group>
                        </td>
                    </tr>
                    <template #footer="{ colspan }">
                        <tr>
                            <td :colspan="colspan" class="text-center">
                                <x-add-item-button @click="addDestination" />
                            </td>
                        </tr>
                    </template>
                </x-table>
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XAddItemButton from "../../components/XAddItemButton.vue";
import XDeleteItemButton from "../../components/XDeleteItemButton.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XTable from "../../components/XTable.vue";
import XInputMember from "../../components/XInputMember.vue";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import Axios from "axios";

export default {
    components: {
        XFormGroup,
        XTable,
        XAddItemButton,
        XDeleteItemButton,
        XInputMember,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            fields: {
                content: null,
                destinations: [],
                title: null,
            },
        };
    },
    methods: {
        addDestination() {
            this.fields.destinations.push({
                phone: null,
                member_id: null,
                name: null,
            });
        },
        deleteDestination(target) {
            this.fields.destinations = [
                ...this.fields.destinations.filter(
                    (destination, index) => index != target
                ),
            ];
        },
        handleSubmit() {
            this.$emit("submit", { ...this.fields });
        },
        async setMember(destination, member) {
            try {
                if (typeof member !== "object") {
                    const response = await Axios.get(`/api/members/${member}`);
                    member = response.data.data;
                }

                this.$set(destination, "member_id", member.id);
                this.$set(destination, "name", member.name);
                this.$set(destination, "phone", member.phone);
            } catch (e) {
                console.error(e);
                this.$notify({
                    type: "error",
                    title: `Error`,
                    text: e.message,
                });
            }
        },
    },
    mixins: [FormErrorMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>
